import {FC} from 'react';
import {useT} from '@kcast-fe/core';
import {Box, Flex} from '@chakra-ui/react';

export const EmptyRecordsInfo: FC = () => {
  const {t} = useT();

  return (
    <Flex flexDirection={'column'} gap={'12px'} alignItems={'center'} maxW={'60%'}>
      <Box textAlign={'center'} fontWeight={600}>
        {t('labels.nothingToShow')}
      </Box>
      <Box textAlign={'center'}>{t('labels.promptsEmpty')}</Box>
    </Flex>
  );
};
